import React from "react";
import Image from "next/image";

import { X } from "lucide-react";

const Header = ({ partnerLogo }: { partnerLogo: string }) => {
  return (
    <div className="bg-white py-6 px-16">
      <div className="flex justify-center items-center py-2 gap-4">
        <Image
          src="/rebolt-branding/rebolt-full-dark.png"
          alt="Rebolt Logo"
          width={100}
          height={100}
          className="h-10 w-auto"
        />
        {partnerLogo && (
          <div className="flex items-center gap-4">
            <X strokeWidth={3} className="w-6 h-6 text-ash-700 " />
            <Image src={partnerLogo} alt="Rebolt Logo" width={100} height={100} className="h-10 w-auto" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
